import React from 'react';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { useTranslation } from 'react-multi-lang';

const AggregateShipments = () => {
    const t = useTranslation();

    return (
        <Card>
            <CardHeader className="bg-primary text-white">
                <h4>{t('aggregateShipments')}</h4>
            </CardHeader>
            <CardBody>
                {/* Empty page to start with */}
            </CardBody>
        </Card>
    );
};

export default AggregateShipments;
